<template>
  <div style="height: 2500px">
    <el-select
      v-model="daytype"
      @change="handleChange"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.text"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <el-table
      :data="tableData"
      v-loading="loading"
      style="width: 100%"
      border
    >

      <el-table-column
        prop="showCount"
        label="曝光量"
      >
      </el-table-column>

      <el-table-column
        prop="clickCount"
        label="点击量"
      >
      </el-table-column>

      <el-table-column
        prop="clickUv"
        label="点击UV"
      >
      </el-table-column>

      <el-table-column
        prop="playCount"
        label="播放量"
      >
      </el-table-column>

      <el-table-column
        prop="playUv"
        label="播放UV"
      >
      </el-table-column>

      <el-table-column
        prop="interactCount"
        label="互动量"
      >
      </el-table-column>

      <el-table-column
        prop="commentShowPv"
        label="评论链接曝光PV"
      >
      </el-table-column>

      <el-table-column
        prop="commentShowUv"
        label="评论链接曝光UV"
      >
      </el-table-column>

      <el-table-column
        prop="commentClickPv"
        label="评论链接点击PV"
      >
      </el-table-column>

      <el-table-column
        prop="commentClickUv"
        label="评论链接点击UV"
      >
      </el-table-column>

      <el-table-column
        prop="searchExpoUv"
        label="搜索曝光UV"
      >
      </el-table-column>
      <el-table-column
        prop="searchBrowseUv"
        label="商详浏览搜索UV"
      >
      </el-table-column>

      <el-table-column
        prop="browseUv"
        label="商详浏览UV"
      >
      </el-table-column>

      <el-table-column
        prop="addCartUv"
        label="商品加购UV"
      >
      </el-table-column>

      <el-table-column
        prop="followUv"
        label="商品收藏UV"
      >
      </el-table-column>

      <el-table-column
        prop="orderUv"
        label="下单UV"
      >
      </el-table-column>

      <el-table-column
        prop="pushSkuOrderUv"
        label="主推商品下单uv"
      >
      </el-table-column>

      <el-table-column
        prop="orderAmount"
        label="下单GMV"
      >
      </el-table-column>

      <el-table-column
        prop="pushSkuOrderAmount"
        label="主推商品下单GMV"
      >
      </el-table-column>

      <el-table-column
        prop="dealUv"
        label="成交UV"
      >
      </el-table-column>

      <el-table-column
        prop="pushSkuDealUv"
        label="主推商品成交uv"
      >
      </el-table-column>

      <el-table-column
        prop="dealAmount"
        label="成交GMV"
      >
      </el-table-column>

      <el-table-column
        prop="pushSkuDealAmount"
        label="主推商品成交GMV"
      >
      </el-table-column>

      <el-table-column
        prop="newBrowseUserNum"
        label="新访客UV"
      >
      </el-table-column>

      <el-table-column
        prop="newBrowseUserNum"
        label="新客UV"
      >
      </el-table-column>

    </el-table>

    <div
      id="myChart"
      :style="{width: '100%', height: '380px'}"
    ></div>
    <el-button
      type="primary"
      @click="downloadAllXhmOrder()"
    >下载订单汇总数据</el-button>
    <el-tabs
      v-model="type"
      @tab-click="handleClick"
    >
      <el-tab-pane
        label="计划"
        name="2"
      >计划</el-tab-pane>
      <el-tab-pane
        label="单元"
        name="3"
      >单元</el-tab-pane>
      <el-tab-pane
        label="创意"
        name="4"
      >创意</el-tab-pane>
    </el-tabs>
    <el-table
      :data="orderTableData"
      v-loading="loading"
      style="width: 100%"
      border
    >
      <el-table-column
        prop="campaignId"
        label="计划ID"
      >
      </el-table-column>

      <el-table-column
        prop="campaignName"
        label="计划名称"
      >
      </el-table-column>

      <el-table-column
        prop="campaignId"
        label="单元ID"
        v-if="type > 2"
      >
      </el-table-column>

      <el-table-column
        prop="campaignName"
        label="单元名称"
        v-if="type > 2"
      >
      </el-table-column>

      <el-table-column
        prop="creativeId"
        label="创意ID"
        v-if="type > 3"
      >
      </el-table-column>

      <el-table-column
        prop="creativeName"
        label="创意名称"
        v-if="type > 3"
      >
      </el-table-column>

      <el-table-column
        prop="costFee"
        label="金额	"
      >
      </el-table-column>

      <el-table-column
        prop="showCount"
        label="曝光量	"
      >
      </el-table-column>

      <el-table-column
        prop="clickCount"
        label="点击量	"
      >
      </el-table-column>

      <el-table-column
        prop="clickUv"
        label="点击UV	"
      >
      </el-table-column>

      <el-table-column
        prop="playCount"
        label="播放量	"
      >
      </el-table-column>

      <el-table-column
        prop="playUv"
        label="播放UV	"
      >
      </el-table-column>

      <el-table-column
        prop="interactCount"
        label="互动量	"
      >
      </el-table-column>

      <el-table-column
        prop="commentShowPv"
        label="评论链接曝光PV	"
      >
      </el-table-column>

      <el-table-column
        prop="commentShowUv"
        label="评论链接曝光UV	"
      >
      </el-table-column>
      <el-table-column
        prop="commentClickPv"
        label="评论链接点击PV	"
      >
      </el-table-column>
      <el-table-column
        prop="commentClickUv"
        label="评论链接点击UV	"
      >
      </el-table-column>

      <el-table-column
        prop="searchExpoUv"
        label="搜索曝光UV	"
      >
      </el-table-column>
      <el-table-column
        prop="searchBrowseUv"
        label="商详浏览搜索UV	"
      >
      </el-table-column>
      <el-table-column
        prop="browseUv"
        label="商详浏览UV	"
      >
      </el-table-column>
      <el-table-column
        prop="addCartUv"
        label="商品加购UV	"
      >
      </el-table-column>

      <el-table-column
        prop="orderAmount"
        label="下单GMV	"
      >
      </el-table-column>
      <el-table-column
        prop="dealAmount"
        label="成交GMV	"
      >
      </el-table-column>
      <el-table-column
        prop="newBrowseUserNum"
        label="新访客UV	"
      >
      </el-table-column>
      <el-table-column
        prop="newUserNum"
        label="新客UV	"
      >
      </el-table-column>

      <!-- <el-table-column
        label="下载数据"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            plain
            class="handel"
            @click="downloadXhmOrder(scope.row)"
          >订单日期明细数据</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>

</template>
<script>
import {
  getProvideDetail,
  getProvideDaily,
  getProvideOrder,
  downloadProvideOrder,
  downloadAllProvideOrder
} from "@/api/providedetail";
import * as echarts from "echarts";

export default {
  data() {
    return {
      taskId: "",
      options: [
        { value: "15", text: "15天" },
        { value: "30", text: "30天" }
      ],
      // 定义选中的值
      daytype: "15", // 默认值
      taskName: "",
      tableData: [],
      orderTableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      type: 2,
      typeName: "计划",
      loading: false
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    ChangeToPercentage(row, column) {
      var data1 = (row[column.property] * 100).toFixed(2) + "%";
      return data1;
    },
    handleClick(tab, event) {
      console.log(tab, event);
      this.type = tab.name;
      this.typeName = tab.label;
      this.getXhmOrder();
    },
    async downFileBlob(fileName, fileBlob) {
      const blob = new Blob([fileBlob], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8"
      });
      const elink = document.createElement("a");
      elink.download = fileName;
      elink.style.display = "none";
      elink.href = URL.createObjectURL(blob);
      document.body.appendChild(elink);
      elink.click();
      URL.revokeObjectURL(elink.href); // 释放URL 对象
      document.body.removeChild(elink);
    },
    // async downloadXhmOrder(val) {
    //   await downloadProvideOrder({
    //     taskId: val.taskId,
    //     orderId: val.mediaOrderId
    //   }).then(res => {
    //     this.downFileBlob(`订单数据_${new Date().getTime()}.xlsx`, res.data);
    //   });
    // },
    async downloadAllXhmOrder() {
      await downloadAllProvideOrder({
        taskId: this.taskId,
        type: this.type,
        dataCycle: this.daytype
      }).then(res => {
        this.downFileBlob(
          `订单汇总数据_${new Date().getTime()}.xlsx`,
          res.data
        );
      });
    },
    async getXhmOrder() {
      this.taskId = this.$route.query.taskId;
      await getProvideOrder({
        taskId: this.taskId,
        pageNo: this.currentPage,
        type: this.type,
        dataCycle: this.daytype
      }).then(res => {
        this.loading = false;
        if (res.code == 1000) {
          this.orderTableData = res.data.content.data;
          this.total = res.data.content.total;
        } else {
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    async search() {
      this.taskId = this.$route.query.taskId;
      this.taskName = this.$route.query.taskName;
      this.loading = true;
      await getProvideDetail({
        taskId: this.taskId,
        dataCycle: this.daytype
      }).then(res => {
        this.loading = false;
        if (res.code == 1000) {
          this.tableData = res.data.contents;
          // this.total = res.data.total;
        } else {
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      }),
        await this.getXhmOrder();
      await getProvideDaily({
        taskId: this.taskId,
        dataCycle: this.daytype
      }).then(res => {
        this.loading = false;
        if (res.code == 1000) {
          // 提取X轴数据和Y轴数据
          let data = res.data.result;
          let xData = data.dataDay;
          let yduv = data.showCount;
          let dzuv = data.clickCount;
          let followUv = data.followUv;
          let commentUv = data.commentShowPv;
          let searchBrowseUv = data.searchBrowseUv;
          let browseUv = data.browseUv;
          let orderGmv = data.orderAmount;
          let orderUv = data.orderUv;
          let dealGmv = data.dealAmount;
          let dealUv = data.dealUv;
          var chartDom = document.getElementById("myChart");
          let myChart = echarts.init(chartDom);
          // 使用ECharts的配置项进行配置
          let option = {
            title: {
              text: this.taskName + "-小红盟每日数据"
            },
            tooltip: {
              trigger: "axis", //坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用
              axisPointer: {
                // 坐标轴指示器，坐标轴触发有效
                type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
              }
            },
            legend: {
              data: [
                "曝光量",
                "点击量",
                "收藏量",
                "评论UV",
                "搜索浏览UV",
                "商品浏览UV",
                "下单GMV",
                "下单UV",
                "成交GMV",
                "成交UV"
              ],
              top: "6%"
            },
            xAxis: {
              type: "category",
              data: xData,
              axisLabel: {
                show: true, //这里的show用于设置是否显示x轴下的字体 默认为true
                interval: 0, //可以设置成 0 强制显示所有标签。如果设置为 1，表示『隔一个标签显示一个标签』，如果值为 2，表示隔两个标签显示一个标签，以此类推。
                textStyle: {
                  //textStyle里面写x轴下的字体的样式
                  color: "#333",
                  fontSize: 13
                },
                rotate: 45
              },
              axisLine: {
                show: true, //这里的show用于设置是否显示x轴那一条线 默认为true
                lineStyle: {
                  //lineStyle里面写x轴那一条线的样式
                  color: "#6FC6F3",
                  width: 2 //轴线的粗细 我写的是2 最小为0，值为0的时候线隐藏
                }
              }
            },
            yAxis: {
              type: "value",
              //用于设置y轴的字体
              axisLabel: {
                show: true, //这里的show用于设置是否显示y轴下的字体 默认为true
                textStyle: {
                  //textStyle里面写y轴下的字体的样式
                  color: "#333",
                  fontSize: 13
                }
              },
              //用于设置y轴的那一条线
              axisLine: {
                show: true, //这里的show用于设置是否显示y轴那一条线 默认为true
                lineStyle: {
                  //lineStyle里面写y轴那一条线的样式
                  color: "#6FC6F3",
                  width: 2 //轴线的粗细 我写的是2 最小为0，值为0的时候线隐藏
                }
              }
            },
            dataZoom: [
              {
                show: true,
                endValue: 9 //x轴少于10个数据，则显示全部，超过10个数据则显示前10个。
              }
            ],
            series: [
              {
                name: "曝光量",
                type: "line",
                data: yduv,
                smooth: true
              },
              {
                name: "点击量",
                type: "line",
                data: dzuv,
                smooth: true
              },
              {
                name: "收藏量",
                type: "line",
                data: followUv,
                smooth: true
              },
              {
                name: "评论UV",
                type: "line",
                data: commentUv,
                smooth: true
              },
              {
                name: "搜索浏览UV",
                type: "line",
                data: searchBrowseUv,
                smooth: true
              },
              {
                name: "商品浏览UV",
                type: "line",
                data: browseUv,
                smooth: true
              },
              {
                name: "下单GMV",
                type: "line",
                data: orderGmv,
                smooth: true
              },
              {
                name: "下单UV",
                type: "line",
                data: orderUv,
                smooth: true
              },
              {
                name: "成交GMV",
                type: "line",
                data: dealGmv,
                smooth: true
              },
              {
                name: "成交UV",
                type: "line",
                data: dealUv,
                smooth: true
              }
            ]
          };
          myChart.setOption(option);
        } else {
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getXhmOrder(); // 重新搜索以更新分页数据
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getXhmOrder(); // 重新搜索以更新分页数据
    },
    handleChange() {
      // 这里执行搜索操作，例如调用API或更新数据
      // 假设有一个search方法来处理搜索逻辑
      this.search();
    }
  }
};
</script>

